import { FormSelectConfig } from '/@/modules/core/form/models/FormSelectConfig';
import { getters } from '/@/modules/core/app/helpers/store';
import Lang from '/@/modules/core/app/services/Lang';

export class CountrySelectConfig extends FormSelectConfig {
  constructor(config = {}) {
    super({
      placeholder: Lang.t('predefined.country'),
      label: 'name',
      trackBy: 'id',
      ...config
    });
  }

  /**
   * @returns {Array.<Country>}
   */
  getOptions(params = {}) {
    if (this.options.length) {
      return this.options;
    }

    return params.showOnlyActive
      ? getters.predefined.getActiveCountries()
      : getters.predefined.getCountries().sort((a, b) => b.active - a.active);
  }
}
